module.exports = __webpack_public_path__ + "/images/ico-blog.6919d07.svg";